import httpClient from './httpClient'

class CreativeApi {
  /**
   * @typedef {("banner"|"in feed"|"video"|"three pas")} CreativeType
   * @param {number} ownerProfileId
   * @param {{ creativeFolderIds: number[], creativeTypes?: CreativeType[], keyword?: string}} query
   */
  static async search(
    ownerProfileId,
    creativeFolderIds,
    creativeTypes,
    auditStatuses,
    keyword,
    pageNo,
    pageSize,
    sortKey,
    sortDirection,
  ) {
    const reqBody = {
      query: {
        creativeFolderIds,
        creativeTypes,
        auditStatuses,
        keyword,
      },
      sortKey,
      sortDirection,
    }
    const params = {
      params: {
        owner_profile_id: ownerProfileId,
      },
    }
    try {
      if (pageNo === undefined && pageSize === undefined) {
        const res = await httpClient.post(
          `/creative/search/all`,
          reqBody,
          params,
        )
        return res.data
      }
      const res = await httpClient.post(
        `/creative/search`,
        {
          ...reqBody,
          pageNo,
          pageSize,
        },
        params,
      )
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  /**
   * @typedef {("active" | "inactive")} StatusType
   * @param {number} id
   * @param {{ name?: string, status?: StatusType, creativeFolderId?: number}} data
   */
  static async update(id, data) {
    try {
      const res = await httpClient.put(`/creative/${id}`, data)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async delete(id) {
    try {
      const res = await httpClient.delete(`/creative/${id}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  // =======================================================
  // バナー
  // =======================================================

  static async createBanner(data) {
    try {
      const res = await httpClient.post(`/creative/banner`, {
        creativeFolderId: data.creativeFolderId,
        name: data.name,
        fileName: data.fileName,
        width: data.width,
        height: data.height,
        landingPageUrl: data.landingPageUrl,
        base64ImageData: data.base64ImageData,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getBanner(id) {
    try {
      const res = await httpClient.get(`/creative/${id}/banner`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async updateBanner(id, data) {
    console.log(data)
    try {
      const res = await httpClient.put(`/creative/${id}/banner`, {
        name: data.name,
        status: data.status,
        fileName: data.fileName,
        width: data.width,
        height: data.height,
        landingPageUrl: data.landingPageUrl,
        base64ImageData: data.base64ImageData,
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  // =======================================================
  // インフィード
  // =======================================================

  static async createInfeed(data) {
    try {
      const req = Object.entries(data).reduce((acc, cur) => {
        if (cur[1] === null) return acc
        return {
          ...acc,
          [cur[0]]: cur[1],
        }
      }, {})
      const res = await httpClient.post(`/creative/infeed`, {
        ...req,
        landingPageUrl: data.landingPageUrl.trim().replace('%20', ' '),
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getInfeed(id) {
    try {
      const res = await httpClient.get(`/creative/${id}/infeed`)
      return res.data.item
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async updateInfeed(id, data) {
    try {
      const req = Object.entries(data).reduce((acc, cur) => {
        if (cur[1] === null) return acc
        return {
          ...acc,
          [cur[0]]: cur[1],
        }
      }, {})
      const res = await httpClient.put(`/creative/${id}/infeed`, {
        ...req,
        landingPageUrl: data.landingPageUrl.trim().replace('%20', ' '),
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async createInfeedByAiGenerator(data) {
    try {
      const res = await httpClient.post(`/creative/aigenerator`, {
        ...data,
        landingPageUrl: data.landingPageUrl.trim().replace('%20', ' '),
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}

export default CreativeApi
